function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { Modal, Radio, Space, Card } from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';
import { useTheme } from '../theme/ThemeContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SWATCH_BORDER = '1px solid rgba(0,0,0,0.1)';

/**
 * Shared theme picker modal. Both consoles open this from the user
 * dropdown so the visual selector is identical everywhere.
 */
export var ThemeSwitcherModal = _ref => {
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useTheme = useTheme(),
    themes = _useTheme.themes,
    currentTheme = _useTheme.currentTheme,
    changeTheme = _useTheme.changeTheme;
  var themeConfig = themes[currentTheme];
  var currentMode = (themeConfig === null || themeConfig === void 0 ? void 0 : themeConfig.mode) || 'light';
  var lightThemes = Object.entries(themes).filter(_ref2 => {
    var _ref3 = _slicedToArray(_ref2, 2),
      t = _ref3[1];
    return t.mode === 'light';
  });
  var darkThemes = Object.entries(themes).filter(_ref4 => {
    var _ref5 = _slicedToArray(_ref4, 2),
      t = _ref5[1];
    return t.mode === 'dark';
  });
  return /*#__PURE__*/_jsx(Modal, {
    title: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(BgColorsOutlined, {
        style: {
          marginRight: 8
        }
      }), "Select Theme"]
    }),
    open: open,
    onCancel: onClose,
    footer: null,
    width: 500,
    children: /*#__PURE__*/_jsxs(Space, {
      orientation: "vertical",
      size: "large",
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h4", {
          style: {
            marginBottom: 12
          },
          children: "Mode"
        }), /*#__PURE__*/_jsxs(Radio.Group, {
          value: currentMode,
          buttonStyle: "solid",
          size: "large",
          onChange: e => {
            var _lightThemes$, _darkThemes$;
            var newMode = e.target.value;
            var first = newMode === 'light' ? (_lightThemes$ = lightThemes[0]) === null || _lightThemes$ === void 0 ? void 0 : _lightThemes$[0] : (_darkThemes$ = darkThemes[0]) === null || _darkThemes$ === void 0 ? void 0 : _darkThemes$[0];
            if (first) {
              changeTheme(first);
            }
          },
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: "light",
            children: "Light"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: "dark",
            children: "Dark"
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h4", {
          style: {
            marginBottom: 12
          },
          children: "Color"
        }), /*#__PURE__*/_jsx(Radio.Group, {
          value: currentTheme,
          onChange: e => changeTheme(e.target.value),
          style: {
            width: '100%'
          },
          children: /*#__PURE__*/_jsx(Space, {
            orientation: "vertical",
            size: "middle",
            style: {
              width: '100%'
            },
            children: (currentMode === 'light' ? lightThemes : darkThemes).map(_ref6 => {
              var _ref7 = _slicedToArray(_ref6, 2),
                key = _ref7[0],
                theme = _ref7[1];
              return /*#__PURE__*/_jsx(Card, {
                size: "small",
                hoverable: true,
                onClick: () => changeTheme(key),
                style: {
                  cursor: 'pointer',
                  border: currentTheme === key ? "2px solid ".concat(theme.primary) : '1px solid #d9d9d9',
                  background: currentTheme === key ? theme.background : 'transparent'
                },
                children: /*#__PURE__*/_jsx(Radio, {
                  value: key,
                  style: {
                    width: '100%'
                  },
                  children: /*#__PURE__*/_jsxs(Space, {
                    children: [/*#__PURE__*/_jsx("span", {
                      style: {
                        fontWeight: currentTheme === key ? 600 : 400
                      },
                      children: theme.name
                    }), /*#__PURE__*/_jsxs("div", {
                      style: {
                        display: 'flex',
                        gap: 4,
                        marginLeft: 8
                      },
                      children: [/*#__PURE__*/_jsx("div", {
                        style: {
                          width: 24,
                          height: 24,
                          borderRadius: 4,
                          background: theme.primary,
                          border: SWATCH_BORDER
                        }
                      }), /*#__PURE__*/_jsx("div", {
                        style: {
                          width: 24,
                          height: 24,
                          borderRadius: 4,
                          background: theme.secondary,
                          border: SWATCH_BORDER
                        }
                      }), /*#__PURE__*/_jsx("div", {
                        style: {
                          width: 24,
                          height: 24,
                          borderRadius: 4,
                          background: theme.logoGradient,
                          border: SWATCH_BORDER
                        }
                      })]
                    })]
                  })
                })
              }, key);
            })
          })
        })]
      })]
    })
  });
};